module.exports = __webpack_public_path__ + "img/test-logo.6325fec1.png";